<template>
  <div>
    <loader :loading="loading"></loader>
    <div class="row">
      <div class="col-md-6 mb-4">
        <h2>Add Link</h2>
        <p v-if="mode !== 1" v-html="surveyTitle"></p>
      </div>
    </div>
    <div v-if="errorMessage.length" class="row">
      <div class="col-md-8">
        <base-alert class="text-center" type="danger" v-html="errorMessage"></base-alert>
      </div>
    </div>
    <validation-observer v-slot="{ handleSubmit }" ref="link">
      <form @submit.prevent="handleSubmit(addLink)">
        <div class="row">
          <div class="col-md-8">
            <validation-provider rules="requiredField" v-slot="{ errors }">
              <base-input
                label="URL"
                addon-left-icon="tim-icons icon-link-72"
                :error="errors[0]"
                v-model="url">
              </base-input>
            </validation-provider>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <base-input
              label="Html"
              addon-left-icon="tim-icons icon-html5"
              v-model="html">
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <base-input
              label="Description"
              addon-left-icon="tim-icons icon-notes"
              v-model="description">
            </base-input>
          </div>
        </div>
        <div class="row">
          <div v-if="mode === 1" class="col-md-4 form-group">
            <label>Survey Name</label>
            <el-select
              @change="onSurveyNameChange()"
              class="select-primary"
              size="large"
              placeholder="Select Survey Name"
              v-model="surveyId">
              <el-option
                class="select-primary"
                :value="nullValue"
                label="">
              </el-option>
              <el-option v-for="s in surveyNames" :key="s.hspSurveyId"
                class="select-primary"
                :value="s.hspSurveyId"
                :label="s.surveyName">
              </el-option>
            </el-select>
          </div>
          <div v-if="mode !== 3" class="col-md-4 form-group">
            <label>Survey Instance</label>
            <el-select
              class="select-primary"
              size="large"
              placeholder="Select Survey Instance"
              v-model="surveyUrlId">
              <el-option
                class="select-primary"
                :value="nullValue"
                label="">
              </el-option>
              <el-option v-for="s in surveyInstances" :key="s.orgSurveyId"
                class="select-primary"
                :value="s.surveyUrlId"
                :label="s.surveyUrlId">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 form-group">
            <label>Role</label>
            <el-select
              class="select-primary"
              size="large"
              placeholder="Select Role"
              v-model="role">
              <el-option
                class="select-primary"
                :value="nullValue"
                label="">
              </el-option>
              <el-option v-for="r in roles" :key="r.id"
                class="select-primary"
                :value="r.id"
                :label="r.name">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 mt-3">
            <base-button native-type="submit" type="primary" class="mb-3">
              Create Link
            </base-button>
          </div>
        </div>
      </form>
    </validation-observer>
  </div>
</template>
<script>
  import Loader from 'src/pages/Survey/Loader';
  import { mapGetters } from 'vuex';
  import { ValidationObserver, ValidationProvider } from 'vee-validate';
  import { BaseAlert } from 'src/components';
  import { Select, Option } from 'element-ui';
  import swal from 'sweetalert2';
  import { addReportLink, getRoles } from 'src/modules/adminActions';
  import { isNullOrEmpty } from '../../modules/utils';

  export default {
    components: {
      Loader,
      [Option.name]: Option,
      [Select.name]: Select,
      ValidationObserver,
      ValidationProvider,
      BaseAlert
    },
    data() {
      return {
        url: null,
        html: null,
        description: null,
        surveyId: null,
        surveyUrlId: null,
        role: null,
        errorMessage: '',
        loading: false,
        roles: [],
        surveyNames: [],
        surveyInstances: [],
        modes: { default: 1, surveyId: 2, surveyUrlId: 3 },
        nullValue: null,
      };
    },
    computed: {
      mode() {
        return this.$route.params.surveyId && this.$route.params.surveyUrlId ? this.modes.surveyUrlId 
          : this.$route.params.surveyId ? this.modes.surveyId
          : this.modes.default;
      },
      surveyNameDisplay() {
        return this.mode === this.modes.surveyId ? this.getSurveyById(this.$route.params.surveyId).surveyName
          : this.$route.params.surveyUrlId;
      },
      surveyTitle() {
        let text = "";
        if (this.$route.params.surveyId) {
          text = "Survey Name: " + this.getSurveyById(this.$route.params.surveyId).surveyName;
          if (this.$route.params.surveyUrlId) {
            text += "<br>Instance: " + this.$route.params.surveyUrlId;
          }
        }
        else if (this.$route.params.surveyUrlId) {
          text = "Survey Instance: " + this.$route.params.surveyUrlId;
        }

        return text;
      },
      orgSurveyId() {
        if (isNullOrEmpty(this.surveyUrlId)) {
          return null;
        }

        return this.getOrgSurveyByUrlId(this.surveyUrlId).orgSurveyId;
      },
      ...mapGetters({
        getSurveyById: 'getSurveyById',
        getOrgSurveyByUrlId: 'getOrgSurveyByUrlId',
        surveys: 'surveys',
      }),
    },
    methods: {
      addLink() {
        this.loading = true;

        this.errorMessage = "";
        let payload = {
          Url: this.url,
          Html: this.html,
          HspSurveyId: this.surveyId,
          OrgSurveyId: this.orgSurveyId,
          RoleId: this.role,
          Description: this.description,
        };

        addReportLink(payload)
        .then(response => {
          let result = response.data;

          this.errorMessage = '';

          if(result.errors && result.errors.length) {
            result.errors.forEach(error => {
              this.errorMessage += `${error}<br>`
            });
          }
          else {
            swal('Link Added!', 'Go to the Links route to verify.', 'success');
            this.url = null;
            this.html = null;
            this.surveyId = null;
            this.surveyUrlId = null;
            this.role = null;
            this.description = null;
            this.$refs.link.reset();
          }
        })
        .finally(() => {
          this.loading = false;
        })
      },
      sortRoles() {
        this.roles.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      },
      initializeSurveyNames() {
        if (this.mode === this.modes.surveyId) {
          this.surveyNames = [this.getSurveyById(this.$route.params.surveyId)];
          this.surveyId = this.$route.params.surveyId;
        }
        else if (this.mode === this.modes.surveyUrlId) {
          const orgSurvey = this.getOrgSurveyByUrlId(this.$route.params.surveyUrlId);
          this.surveyNames = [this.getSurveyById(orgSurvey.hspSurveyId)];
          this.surveyId = this.surveyNames[0].hspSurveyId;
          this.surveyUrlId = this.$route.params.surveyUrlId;
        }
        else {
          this.surveyNames = this.surveys;
        }
      },
      updateSurveyInstances(surveyId) {
        if (isNullOrEmpty(surveyId)) {
          return;
        }
        this.surveyInstances = this.surveyNames.find(x => x.hspSurveyId === surveyId).orgSurveys;
      },
      onSurveyNameChange() {
        this.surveyUrlId = null;
      },
    },
    watch: {
      surveyId: function (newValue, oldValue) {
        this.updateSurveyInstances(newValue);
      }
    },
    created() {
      var params = this.$route.params;
      this.initializeSurveyNames();
      getRoles()
        .then((response) => {
          this.roles = response.data.filter(x => x.name !== 'administrator' && x.name !== 'analyst');
          this.sortRoles();
        });
    },
  }
</script>
